import React, { memo } from 'react';

import { ICard } from '../interfaces';

export const CardModal = memo<ICard>(({ cardNumber, expirationDate }) => (
  <>
    <div className="font-medium-base mb-3">Карта</div>
    <div className="mb-3">
      <div className="font-regular-sm text-muted">4 последние цифры</div>
      <div className="font-regular-base">{cardNumber}</div>
    </div>
    <div className="mb-3">
      <div className="font-regular-sm text-muted">Месяц / год</div>
      <div className="font-regular-base">{expirationDate}</div>
    </div>
  </>
));
